import { EMAIL_PATTERN } from '@/modules/utils/patterns';
export default function SeniorDetails({ applicantInfo, setApplicantInfo }) {
	const {
		firstName,
		lastName,
		email,
		phoneNumber,
		dob,
		addressLine1,
		ssn,
		city,
		state,
		zipCode,
		gender,
		lifeEvents
	} = applicantInfo;

	const handleChange = (e) => {
		const { name, value } = e.target;

		setApplicantInfo((prevState) => {
			return {
				...prevState,
				[name]: value
			};
		});
	};

	return (
		<>
			<h2 className="border-b-2 mb-4 md:text-2xl font-semibold">
				Applicant Information
			</h2>
			<div className="grid grid-cols-6 gap-6">
				<div className="col-span-6 sm:col-span-3">
					<label
						htmlFor="first-name"
						className="block text-sm font-medium text-gray-700"
					>
						First name
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						required
						name="firstName"
						value={firstName}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>

				<div className="col-span-6 sm:col-span-3">
					<label
						htmlFor="last-name"
						className="block text-sm font-medium text-gray-700"
					>
						Last name
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="lastName"
						required
						value={lastName}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>

				<div className="col-span-6 sm:col-span-3">
					<label
						htmlFor="email-address"
						className="block text-sm font-medium text-gray-700"
					>
						Email address
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="email"
						name="email"
						value={email}
						pattern={EMAIL_PATTERN}
						autoComplete="email"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
				<div className="col-span-6 sm:col-span-3 sm:col-start-1">
					<label
						htmlFor="phoneNumber"
						className="block text-sm font-medium text-gray-700"
					>
						Phone Number
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="tel"
						required
						maxLength="20"
						name="phoneNumber"
						value={phoneNumber}
						placeholder="333-333-3333"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md placeholder-gray-300"
					/>
				</div>
				<div className="col-span-6 sm:col-span-2 sm:col-start-1">
					<label
						htmlFor="dob"
						className="block text-sm font-medium text-gray-700"
					>
						Date of Birth
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="date"
						name="dob"
						required
						value={dob}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md placeholder-gray-300"
					/>
				</div>
				<div className="col-span-6 sm:col-span-2">
					<label
						htmlFor="dob"
						className="block text-sm font-medium text-gray-700"
					>
						Last 4 of Your SSN
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="ssn"
						value={ssn}
						required
						maxLength="4"
						pattern="\d\d\d\d"
						placeholder="1234"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md placeholder-gray-300"
					/>
				</div>
				<div className="col-span-6 sm:col-span-2">
					<label
						htmlFor="gender"
						className="block text-sm font-medium text-gray-700"
					>
						Gender
					</label>
					<select
						onChange={(e) => handleChange(e)}
						name="gender"
						className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-emerald-300 focus:border-emerald-300 sm:text-sm rounded-md"
						defaultValue="Choose"
					>
						<option disabled>Choose</option>
						<option>Male</option>
						<option>Female</option>
					</select>
				</div>

				<div className="col-span-6 mt-6">
					<label
						htmlFor="addressLine1"
						className="block text-sm font-medium text-gray-700"
					>
						Street Address
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						required
						name="addressLine1"
						value={addressLine1}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>

				<div className="col-span-6 sm:col-span-6 lg:col-span-2">
					<label
						htmlFor="city"
						className="block text-sm font-medium text-gray-700"
					>
						City
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="city"
						value={city}
						required
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>

				<div className="col-span-6 sm:col-span-3 lg:col-span-2">
					<label
						htmlFor="state"
						className="block text-sm font-medium text-gray-700"
					>
						State / Province
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="state"
						value={state}
						required
						placeholder="PA"
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md placeholder-gray-300"
					/>
				</div>

				<div className="col-span-6 sm:col-span-3 lg:col-span-2">
					<label
						htmlFor="postal-code"
						className="block text-sm font-medium text-gray-700"
					>
						ZIP / Postal
					</label>
					<input
						onChange={(e) => handleChange(e)}
						type="text"
						name="zipCode"
						value={zipCode}
						autoComplete="postal-code"
						required
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
				<div className="col-span-6 ">
					<label
						htmlFor="lifeEvents"
						className="block text-sm font-medium text-gray-700"
					>
						Any major life events or impacts in the last year?
						(Optional)
					</label>
					<textarea
						onChange={(e) => handleChange(e)}
						type="text"
						rows="3"
						name="lifeEvents"
						value={lifeEvents}
						className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
					/>
				</div>
			</div>
		</>
	);
}
